var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookingTvArabic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.4,
    viewBox: "0 0 18 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cooking_Tv_Arabic",
    "data-name": "Cooking Tv Arabic",
    transform: "translate(-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    "data-name": "Group 1858",
    transform: "translate(1.8 1.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8999",
    "data-name": "Path 8999",
    d: "M20.15,16.6h-9.9A2.253,2.253,0,0,1,8,14.35V4.45A.45.45,0,0,1,8.45,4h13.5a.45.45,0,0,1,.45.45v9.9A2.253,2.253,0,0,1,20.15,16.6ZM8.9,4.9v9.45a1.352,1.352,0,0,0,1.35,1.35h9.9a1.352,1.352,0,0,0,1.35-1.35V4.9Z",
    transform: "translate(-8 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    "data-name": "Group 1859",
    transform: "translate(0 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9000",
    "data-name": "Path 9000",
    d: "M6.25,10.9H4.45a.45.45,0,1,1,0-.9h1.8a.45.45,0,1,1,0,.9Z",
    transform: "translate(-4 -10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860",
    transform: "translate(15.3 4.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9001",
    "data-name": "Path 9001",
    d: "M40.25,10.233h-1.8a.45.45,0,1,1,0-.9h1.8a.45.45,0,1,1,0,.9Z",
    transform: "translate(-38 -9.333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(0.9 1.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9002",
    "data-name": "Path 9002",
    d: "M21.75,4.9H6.45a.45.45,0,1,1,0-.9h15.3a.45.45,0,0,1,0,.9Z",
    transform: "translate(-6 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862",
    transform: "translate(6.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9003",
    "data-name": "Path 9003",
    d: "M23.05,2.7a.45.45,0,0,1-.45-.45,1.35,1.35,0,0,0-2.7,0,.45.45,0,1,1-.9,0,2.25,2.25,0,0,1,4.5,0A.45.45,0,0,1,23.05,2.7Z",
    transform: "translate(-19)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingTvArabic);
export default __webpack_public_path__ + "static/media/Cooking-Tv-Arabic.c05618d721b226071106606df97064ff.svg";
export { ForwardRef as ReactComponent };